import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import SisterSiteStrip from "@/components/SisterSiteStrip";

/**
 * Sister-site promo block on the Home page. Routes SJDS visitors to:
 *  - Popoyo.app (sister surf hub up the coast)
 *  - DigitalNomadNicaragua.com (remote-work resource hub by Greg Miceli)
 */
export default function PopoyoPromoStrip() {
  const { t } = useI18n();

  return (
    <div data-testid="sister-sites-block" className="mb-6">
      <SisterSiteStrip
        testId="popoyo-promo-strip"
        href="https://www.popoyo.app"
        logoSrc="/brand/popoyo-app-logo.png"
        logoAlt="Popoyo.app"
        logoBg="#1B3B6F"
        pitchLead={t("sister_popoyo_lead")}
        pitchBrand="Popoyo.app"
        accent="var(--teal)"
        bgGradient="linear-gradient(90deg, #F5F7F0 0%, #E5F3F1 100%)"
        borderColorVar="rgba(46,196,182,0.3)"
        visitLabel={t("sister_visit")}
      />
      <SisterSiteStrip
        testId="dnn-promo-strip"
        href="https://www.DigitalNomadNicaragua.com"
        logoSrc="/brand/digital-nomad-nicaragua-logo.jpg"
        logoAlt="Digital Nomad Nicaragua"
        logoBg="#FFFFFF"
        pitchLead={t("sister_dnn_lead")}
        pitchBrand="DigitalNomadNicaragua.com"
        accent="#0E7490"
        bgGradient="linear-gradient(90deg, #ECFEFF 0%, #CFFAFE 100%)"
        borderColorVar="rgba(14,116,144,0.3)"
        visitLabel={t("sister_visit")}
      />
    </div>
  );
}
